module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-toolbar p-component mb-4"
  }, [_c('itemGroupDialog', {
    ref: "itemGroupdialog"
  })], 1), _vm._v(" "), _c('itemgrouplist', {
    on: {
      "delete-message": _vm.deleteMessage,
      "edit-group": _vm.editItemGroup
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cad6320"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/item/Itemgroup.vue
// module id = 2294
// module chunks = 0